/**
 * 콘텐츠 ID별 메타데이터 매핑 (임시)
 *
 * 백엔드 API에서 thumbnailUrl, curriculumType을 제공하기 전까지
 * 프론트엔드에서 직접 매핑하여 사용합니다.
 *
 * 이미지 파일: public/images/content/ 에 저장
 * 참조 URL: /images/content/{filename}
 */

interface ContentMetadata {
  thumbnailUrl: string | null;
  curriculumType: string | null;
}

const CONTENT_METADATA: Record<number, ContentMetadata> = {
  // 예시 - 실제 contentId로 교체하세요
  2354: {
    thumbnailUrl: '/images/content/content-2354-thumbnail.png',
    curriculumType: '공통',
  },
  2163: {
    thumbnailUrl: '/images/content/content-2163-thumbnail.png',
    curriculumType: '사원',
  },
  2165: {
    thumbnailUrl: '/images/content/content-2165-thumbnail.png',
    curriculumType: '팀장',
  },
};

const DEFAULT_METADATA: ContentMetadata = {
  thumbnailUrl: null,
  curriculumType: '공통',
};

export function getContentMetadata(contentId: number | null): ContentMetadata {
  if (!contentId) return DEFAULT_METADATA;
  return CONTENT_METADATA[contentId] ?? DEFAULT_METADATA;
}
